import React from 'react';
import ServiceBody from './ServiceBody';
import ServiceDialog from './ServiceDialog';

/** 旅CUBE版のサービス概要。 */
const ServiceOverview: React.FC = () => {
  return (
    <ServiceDialog>
      <ServiceBody/>
    </ServiceDialog>
  );
}

export default ServiceOverview;
